// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-src_bootstrap_ts":"b7e217c95eb0f5de","src_app_pages_report_report_module_ts":"7c6e2946545b2b3c","src_assets_i18n_allspark_en_json":"9d67b1649a24288e","src_assets_i18n_allspark_fr_json":"db1707c2d134df76","src_assets_i18n_en_json":"f3d9ede6b6cde08e"}[chunkId] + ".js";
};